<!-- 发送命令-额外参数 -->
<!-- 额外参数JSON格式，参数如下：
	 显示名称："key_cn"  //页面中显示的名称
	 参数名称："key_en" //组装json的字段
	 参数编码："code"
	 参数类型："value_type"
	 数据源： "data_source" //对应参数类型中下拉框、单选框、多选框
	 是否必填："is_null":false  //是否允许null，和字面意思相反
 
	 其中参数类型选择的下拉框数据（key-value）约定如下：
	 文本：input
	 下拉框：select
	 单选框：radio
	 多选框：checkbox
	 数字框：input-number
	 年：yy
	 年月：yy-MM
	 年月日：yy-MM-dd
	 年月日时分秒：yy-MM-dd HH:mm:ss
 
	 数据源使用json格式，填写key,value的JSON格式。如:
	 [{
	     "key":"Daily",
	     "value":"日数据"
	 },
	 {
	     "key":"Minutely",
	     "value":"分钟数据"
	 },
	 {
	     "key":"Realtime",
	     "value":"实时数据"
	 },
	 {
	     "key":"Hourly",
	     "value":"小时数据"
	 }] -->
<template>
  <el-dialog
    :title="command.Name + '-额外参数'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="5vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="140px">
      <el-form-item
        v-for="params in command.ExtraParams"
        :key="params.key_en"
        :prop="params.key_en"
        :label="params.key_cn"
        :rules="
          params.is_null
            ? [
                {
                  required: false,
                },
              ]
            : [
                {
                  required: true,
                  message: params.key_cn + '不能为空',
                  trigger: 'blur',
                },
              ]
        "
      >
        <el-input
          v-model="item[params.key_en]"
          v-if="params.value_type === 'input'"
          :placeholder="'请输入' + params.key_cn"
        ></el-input>
        <el-select
          v-model="item[params.key_en]"
          default-first-option
          :clearable="false"
          style="width: 100%"
          :placeholder="'请选择' + params.key_cn"
          v-else-if="params.value_type === 'select'"
        >
          <el-option
            v-for="source in params.data_source"
            :key="source.key"
            :label="source.value"
            :value="source.key"
          ></el-option>
        </el-select>
        <el-radio-group
          v-model="item[params.key_en]"
          v-if="params.value_type === 'radio'"
        >
          <el-radio
            v-for="source in params.data_source"
            :key="source.key"
            :label="source.key"
          >
            {{ source.value }}
          </el-radio>
        </el-radio-group>
        <el-checkbox-group
          v-model="item[params.key_en]"
          v-if="params.value_type === 'checkbox'"
        >
          <el-checkbox
            v-for="source in params.data_source"
            :key="source.key"
            :label="source.key"
          >
            {{ source.value }}
          </el-checkbox>
        </el-checkbox-group>
        <el-input-number
          v-model="item[params.key_en]"
          v-if="params.value_type === 'input-number'"
          style="width: 100%"
        ></el-input-number>
        <el-date-picker
          v-model="item[params.key_en]"
          v-if="params.value_type === 'yy-MM-dd HH:mm:ss'"
          :placeholder="'请选择' + params.key_cn"
          style="width: 100%"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-date-picker
          v-model="item[params.key_en]"
          v-if="params.value_type === 'yy-MM-dd'"
          :placeholder="'请选择' + params.key_cn"
          style="width: 100%"
          type="date"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-date-picker
          v-model="item[params.key_en]"
          v-if="params.value_type === 'yy'"
          :placeholder="'请选择' + params.key_cn"
          style="width: 100%"
          type="year"
          value-format="yyyy"
        ></el-date-picker>
        <el-date-picker
          v-model="item[params.key_en]"
          v-if="params.value_type === 'yy-MM'"
          :placeholder="'请选择' + params.key_cn"
          style="width: 100%"
          type="month"
          value-format="yyyy-MM"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <el-form :model="extraItem" ref="extraItemform" label-width="140px">
      <el-form-item
        label="额外参数"
        prop="extraParams"
        :rules="{
          required: true,
          message: '额外参数不能为空',
          trigger: 'blur',
        }"
        ><span slot="label">
          <span>
            <span
              >额外参数
              <el-popover
                placement="top-start"
                width="250"
                trigger="hover"
                content=""
                ><div>根据上面各字段填写情况,自动拼装成json语句</div>
                <i
                  slot="reference"
                  class="el-icon-info"
                  style="color: #409eff"
                ></i>
              </el-popover>
            </span>
          </span>
        </span>
        <el-input
          v-model.trim="extraItem.extraParams"
          :autosize="{ minRows: 5 }"
          type="textarea"
          placeholder="请输入额外参数"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 发 送
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  //command快捷命令 quickSendInfo发送命令信息
  props: { command: Object, quickSendInfo: Object, visible: Boolean },
  data() {
    return {
      item: {}, //额外参数实体
      extraItem: {
        extraParams: "",
      }, //额外参数
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
    item: {
      handler(newVal, oldVal) {
        this.extraItem.extraParams = JSON.stringify(this.item);
      },

      //立即执行
      immediate: true,
      //深度监听
      deep: true,
    },
  },
  methods: {
    onOpen() {
      this.initData();
    },
    initData() {
      this.item = {};
      for (var i = 0; i < this.command.ExtraParams.length; i++) {
        var params = this.command.ExtraParams[i];
        var key = params.key_en;
        if (params.value_type === "checkbox") {
          this.$set(this.item, key, []);
        } else {
          this.$set(this.item, key, "");
        }
      }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.$refs.extraItemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$refs.extraItemform.validate((valid1) => {
          if (!valid1) {
            return;
          }
          this.submitting = true;

          var payloadJson = []; //JSON格式的命令内容
          try {
            payloadJson = JSON.parse(this.quickSendInfo.Payload); // 如果不是json字符串就会抛异常
          } catch (e) {
            this.$message({
              type: "warning",
              message: "配置的命令内容JSON格式错误:" + e,
              duration: 1500,
            });
            return;
          }

          var extraJson = []; //JSON格式的额外参数
          var extraStr = ""; //重新组装额外参数字符串
          try {
            extraJson = JSON.parse(this.extraItem.extraParams); // 如果不是json字符串就会抛异常

            //重新组装额外参数字符串
            for (var key in extraJson) {
              if (extraJson[key] instanceof Array) {
                var arrstr = "[";
                extraJson[key].forEach((e) => {
                  arrstr += "'" + e + "'";
                });
                arrstr += "]";
                extraStr += " " + key + "=" + arrstr;
              } else if (typeof extraJson[key] == "number") {
                extraStr += " " + key + "=" + extraJson[key];
              } else {
                extraStr += " " + key + "='" + extraJson[key] + "'";
              }
            }
            extraStr =
              extraStr === "" ? "" : extraStr.slice(1, extraStr.length);
          } catch (e) {
            this.$message({
              type: "warning",
              message: "额外参数JSON格式错误:" + e,
              duration: 1500,
            });
            return;
          }

          // 组装额外参数到发送内容中
          this.findExtraParamsIndex(payloadJson, extraStr);
          this.quickSendInfo.Payload = JSON.stringify(payloadJson);

          // 发送快捷命令
          this.$axios
            .post("dci/communication/customcontrol", this.quickSendInfo)
            .then(() => {
              this.$message.success("发送成功");
              this.submitting = false;
              this.$emit("form:saved", true);
              this.$emit("update:visible", false);
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
              this.submitting = false;
              this.$emit("form:saved", false);
            });
        });
      });
    },
    findExtraParamsIndex(obj, extraStr) {
      for (var i in obj) {
        //判断是否为object 有就再从此层级开始循环
        if (typeof obj[i] == "object") {
          this.findExtraParamsIndex(obj[i], extraStr); //递归遍历所有下层对象
        } else {
          if (i === this.command.ExtraIndex) {
            //找出额外参数索引字段
            obj[i] = obj[i] + ' "' + extraStr + '"';
          }
        }
      }
    },
  },
};
</script>
